import React from "react";
import { useSelector } from "react-redux";

import { MdManageAccounts, MdStore, MdChat, MdMoreHoriz } from "react-icons/md";
import { FaShippingFast, FaDigitalTachograph } from "react-icons/fa";

import AdminProfileModal from "./Components/ProfileModal/AdminProfileModal";
import Navbar from "./Navbar";

const AdminNavBar = () => {
  const user = useSelector((state) => state.user);

  const navItems = [
    {
      label: "Clients",
      i18nKey: "nav:clients",
      url: "/Users",
      icon: MdManageAccounts,
    },
    {
      label: "Carriers",
      i18nKey: "nav:carriers",
      url: "/companies",
      icon: MdStore,
    },
    {
      label: "Tickets",
      i18nKey: "nav:tickets",
      url: "/tickets-admin",
      icon: MdChat,
    },
    {
      label: "Shipments",
      i18nKey: "nav:shipments",
      url: "/shipments-admin",
      icon: FaShippingFast,
    },
    {
      label: "Finances",
      i18nKey: "nav:finances",
      url: "/payments-admin",
      icon: FaDigitalTachograph,
    },
    {
      label: "Quotes",
      i18nKey: "nav:quotes",
      url: "/quotes-admin",
      icon: FaDigitalTachograph,
    },
    {
      label: "More",
      i18nKey: "nav:more",
      url: "/user/Newsletter",
      icon: MdMoreHoriz,
    },
  ];

  const profileModal = ({ onClose }) => (
    <AdminProfileModal onClose={onClose} style={{ top: "50px", right: "0 " }} />
  );

  return (
    <>
      <Navbar
        navItems={navItems}
        profileImage={user?.profile_image}
        profileModal={profileModal}
      />
    </>
  );
};

export default AdminNavBar;
